export function parseArrivalDate(value: string | undefined): Date | null {
  if (!value || !value.trim()) return null
  const s = value.trim()
  const iso = s.match(/^\d{4}-\d{2}-\d{2}(T|\s)/)
  if (iso) {
    const d = new Date(s.replace(' ', 'T'))
    return Number.isNaN(d.getTime()) ? null : d
  }
  const dm = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{2}))?/)
  if (dm) {
    const [, day, month, year, hour = '12', min = '0'] = dm
    const d = new Date(+year, +month - 1, +day, +hour, +min, 0, 0)
    return Number.isNaN(d.getTime()) ? null : d
  }
  const d = new Date(s)
  return Number.isNaN(d.getTime()) ? null : d
}

export type Countdown = {
  days: number
  hours: number
  minutes: number
  seconds: number
  isExpired: boolean
}

export function getCountdown(target: Date | null): Countdown {
  if (!target) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true }
  }
  const now = new Date()
  let diff = target.getTime() - now.getTime()
  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true }
  }
  const days = Math.floor(diff / (24 * 60 * 60 * 1000))
  diff -= days * 24 * 60 * 60 * 1000
  const hours = Math.floor(diff / (60 * 60 * 1000))
  diff -= hours * 60 * 60 * 1000
  const minutes = Math.floor(diff / (60 * 1000))
  diff -= minutes * 60 * 1000
  const seconds = Math.floor(diff / 1000)
  return { days, hours, minutes, seconds, isExpired: false }
}

export function formatCountdown(c: Countdown): string {
  if (c.isExpired) return '0 д 00 : 00 : 00'
  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${c.days} д ${pad(c.hours)} : ${pad(c.minutes)} : ${pad(c.seconds)}`
}
